import React from 'react';
import cx from 'classnames';

import Button from '~/components/button';
import { pages } from '~/components/modals/small-lawn/small-lawn-modal';
import { formatNumber } from '~/utils/numbers';

import styles from '~/components/modals/modal.module.scss';

const SmallLawnModalForm = ({
  onSubmit,
  lawnSqFt,
  smallLawnThreshold,
  onClose,
}) => (
  <div className={styles.container}>
    <h1 className={styles.title}>Small lawn</h1>

    <p className={cx(styles.text, styles.centerAlign)}>
      At <strong className="highlight">{formatNumber(lawnSqFt)} sq. ft</strong>,
      your lawn is smaller than the minimum treatment area for our custom lawn
      plans. Our smallest plan includes nutrient rates optimized to feed a{' '}
      <strong>
        {formatNumber(smallLawnThreshold, { round: true })} sq. ft
      </strong>{' '}
      lawn.{' '}
      <Button
        type="button"
        variant="link"
        onClick={() => onSubmit({ type: 'navigate', payload: pages.SEE_WHY })}
        style={{ padding: '2rem 0 0' }}
      >
        See why here
      </Button>
    </p>

    <div className={styles.buttons}>
      <Button
        onClick={() => onSubmit({ type: 'requestOrderAnyway' })}
        fullWidth
        data-testid="small-lawn-submit"
      >
        I'd like to order anyway
      </Button>
      <Button
        variant="link"
        fullWidth
        onClick={onClose}
        style={{ marginTop: '1rem' }}
      >
        I'd like to adjust my lawn size
      </Button>
    </div>
  </div>
);

export default SmallLawnModalForm;
